module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/qr-code-postauth-60f8117a1160edb145d5407ca216a573.png";